"use client";
import { useEffect as r } from "react";
const s = (e, n) => {
  r(() => {
    const t = (o) => {
      e.current && !e.current.contains(o.target) && n();
    };
    return document.addEventListener("mousedown", t), () => {
      document.removeEventListener("mousedown", t);
    };
  }, [e]);
};
export {
  s as useOutsideRefClickCallback
};
//# sourceMappingURL=index.es90.js.map
